<template>
  <!-- 填空题 -->
  <div
    class="fill-topic topic-box"
    :class="{'topic_red': answerSheet.acRedCard}"
    @mouseleave="showTopicEditorBox = false"
    @mouseenter="handleMouseEnter"
  >
    <TopicEditBox v-if="showTopicEditorBox" :msg="msg"></TopicEditBox>
    <!-- <custom-edit-box v-if="!msg.resolveNum&&msg.isEdit&&!isPreview" :msg="msg" :isDis="isDis" /> -->
    <div class="topic-th" v-if="msg.hasTitle">
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div v-else>
      <EditScoreBox
        :msg="msg"
        @myBlur="handlerBlur"
        :isPreview="isPreview"
      ></EditScoreBox>
    </div>
    <div
      class="topic-bd fill-cont fill-warp"
      :data-th="setData"
      :style="{
        height: (msg.initDragHeight || 300) + 'px',
        border: showTopicEditorBox ? '1px solid #409eff !important' : '',
      }"
    >
      <div class="drag_mark" v-show="showTopicEditorBox"></div>

      <template v-if="isPreview">
        <div class="ck-content" v-html="msg.innerHTML"></div>
      </template>
      <template v-else>
        <!-- <ckeditor
          class="ck-editor"
          :id="msg.id"
          :editor="editor"
          v-model="msg.innerHTML"
          :config="ckeditorConfig"
        ></ckeditor>-->
        <MyUEditor
          :msg="msg"
          @onMouseEnter="showTopicEditorBox = false"
          @onMouseDown="handleMouseDown"
          @onBlur="handleBlur"
        ></MyUEditor>
      </template>
      <!-- <div class="move-h" :id="fillMove" v-show="fillTopic.resolveEnd&&fillTopic.isEdit">
        <span class="el-icon-sort"></span>
      </div>-->
    </div>

    <!-- <div class="move-tips" v-show="fillTopic.isMoveN">松开会向下分页</div>
    <div class="move-tips" v-show="fillTopic.isMoveP">
      <span v-if="!fillTopic.resolveNum||fillTopic.typesItem.groupHArry.length>0">已是最小高度值</span>
      <span v-else>松开会删除此项</span>
    </div>-->
    <!--主体-->
    <div class="drag_button" id="drag_button" v-show="showTopicEditorBox">
      <i class="el-icon-rank" style="font-size: 22px"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions,mapGetters } from "vuex";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";
import CustomEditBox from "@/components/TopicMakeBox/CustomEditBox";
import cardOperate from "@/assets/js/utils/cardOperate";
import FillTopic from "@/assets/js/utils/FillTopic";
import MyDrag from "@/assets/js/utils/base/MyDrag";
import VueUeditorWrap from "vue-ueditor-wrap";
import { CKEDITOR_CONFIG } from "@/subjects/constant";
import { TAG_P_HEIGHT } from "@/subjects/constant";
//import JQ from "jquery";
export default {
  name: "fillTopic",
  props: {
    msg: Object,
    isPreview: Boolean,
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  components: {
    VueUeditorWrap,
    // CustomEditBox
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("card", {
      blankSignal: (state) => state.blankSignal,
      existHeight: (state) => state.existHeight,
      pageCell: (state) => state.pageCell,
      subjects: (state) => state.subjects,
      currentPageNum: (state) => state.currentPageNum,
      newTopicHeight: (state) => state.newTopicHeight,
    }),
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet"
    }),
    rowNum() {
      if (this.msg.typesItem.rowNum < 1) {
        return this.msg.typesItem.rowNum.toString().split(".");
      } else {
        return [this.msg.typesItem.rowNum];
      }
    },
    setData: function () {

      return this.msg.th;
    },
  },
  data() {
    return {
      showTopicEditorBox: false,
      myFillTopic: undefined,
      myDrag: undefined,
      ckeditorConfig: CKEDITOR_CONFIG,
      place: "&nbsp;",
      placeholder: "&nbsp;&nbsp;&nbsp;&nbsp;",
      wTotal: 0,
      htmlContent: "",
      editorData: "",
      isDis: false,
      resolveEnd: true,
      fillMove: "fill-move",
      editor: null,
      num: 0,
    };
  },
  created() {
    this.editor = this.$ckEditor;
  },
  mounted() {
    // 这个操作永远在store更新视图之后执行
    const target = document.querySelectorAll(".topic-bd");
    this.myDrag = new MyDrag(target);
    this.myFillTopic = new FillTopic({
      width: 1107,
      height: 706,
      canDrag: true,
      myDrag: this.myDrag,
    });
    this.myFillTopic.init();
    // setTimeout(() => {
    //   if (this.blankSignal) {
    //     myFillTopic.recursionCutPage(
    //       this.pageCell.length - 1,
    //       this.existHeight
    //     );
    //     this.setBlankSignal(false);
    //   }
    // }, 200);


  },
  methods: {
    ...mapMutations({
      setBlankSignal: "card/setBlankSignal",
      setCurrentPageNum: "card/setCurrentPageNum",
      updatePageCell: "card/updatePageCell",
      updateSubjects: "card/updateSubjects",
    }),
    getFillData() {
      const contBox = document.querySelectorAll('.page-cell')
        const fillPos= [];
        contBox.forEach(box =>{
          const contRect = box.getBoundingClientRect();
          const items = box.querySelectorAll('.fill-item');

          items.forEach(item => {
            const itemRect = item.getBoundingClientRect();
            fillPos.push({
              x: itemRect.left - contRect.left,
              y: itemRect.top - contRect.top,
              width: itemRect.width,
              height: itemRect.height,
            });
          });

      });
      return {
        index: this.msg.pageIndex, // 从父组件传递的当前索引
        data: fillPos // 子组件的数据
      };
    },
    async handleBlur(data) {
      this.setCurrentPageNum(this.msg.pageIndex);
      const { editorHeight, content, overstepDistance } = data;
      // const height = this.msg.initDragHeight + pNums * TAG_P_HEIGHT;
      await this.updatePageCell({
        currentIndexInPage: this.msg.currentIndexInPage,
        initDragHeight: editorHeight,
        innerHTML: content,
      });
      const timerUpdate = setTimeout(() => {
        // 这里最好使用异步的方法处理 不影响其他代码的执行
        // 在这里处理自定义编辑的问题 blur的时候把高度 html存储到subjects里面去
        // 记录当前编辑的subject下标 循环的时候把使用下标让上面的题型保持不变 下面的题型重新appendToPage
        let sameTopicList = []; // 把整个页面的pagecell的filltopiclist中属于该题号的题型stack存起来
        this.pageCell.forEach((page) => {
          page.fillTopiclist.forEach((topic) => {
            if (topic.th == this.msg.th) {
              sameTopicList.push(topic);
            }
          });
        });
        let subjectContainer = { initDragHeight: 0, innerHTML: "" }; // 用来存储html和高度
        this.subjects.forEach(async (subject, index) => {
          if (subject.th == this.msg.th) {
            // 题号相等的说明属于该题型的分解 然后记录下该下标
            sameTopicList.forEach((sameTopic) => {
              subjectContainer.initDragHeight += sameTopic.initDragHeight || 0; //给subject对象赋予高度
              subjectContainer.innerHTML += sameTopic.innerHTML || "";
            });
            subject.setHtml(subjectContainer.innerHTML);
            subject.setInitDragHeight(subjectContainer.initDragHeight);
            subject.setFromEdit(false);
            await this.updateSubjects({
              index: index,
              data: subject,
            });
          }
        });
        console.log("失焦处理的数据", this.msg, this.subjects, sameTopicList);
        clearTimeout(timerUpdate);
      }, 100);
      const timer = setTimeout(() => {
        overstepDistance > 0 &&
          this.myFillTopic.updateViewHeight(
            overstepDistance,
            undefined,
            undefined,
            "blur"
          );
      }, 200);
    },
    handleMouseDown() {
      console.log("mousedown");
    },
    // handleMouseEnter() {
    //   !this.isPreview && (this.showTopicEditorBox = true);
    // },
  },
  watch: {
    editorData: function (valNew, valOld) {
      // console.log(valNew,'xxx1')
      // console.log(valOld,'xxx2')
      if (this.htmlContent != valNew) {
        //编辑器操作过后不能设置
        this.isDis = true;

      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fill-cont {
  p {
    margin-top: 39px; //15+39=54
  }
}
.cx-editor {
  pointer-events: none;
}
.topic-box {
  // border: 1px solid #000;
  .drag_button {
    display: none;
    position: absolute;
    bottom: 6px;
    right: 6px;
    z-index: 222222;
    pointer-events: none;
    .el-icon-rank {
      display: block;
      color: #409eff;
      cursor: n-resize;
    }
    .drag_i_active {
    }
  }
  .drag_mark {
    position: absolute;
    bottom: -30px;
    right: -30px;
    width: 80px;
    height: 80px;
    z-index: 222222;
    // cursor:s-resize;
    cursor: row-resize;
  }
  .drag_button:hover {
  }
}
.topic-box:hover .drag_button {
  display: block;
}
// .topic-box:hover .topic-bd {
//   border: 1px solid #409eff !important;
// }
.ck-content {
  padding-top: 16px !important;
}
.fill-item{
  color: var(--card-color) !important;
}
</style>
